module.exports = __webpack_public_path__ + "static/img/arthroscopy-11.5b60d43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-11.jpg
// module id = B4Nn
// module chunks = 51